// extracted by mini-css-extract-plugin
module.exports = {"root":"AcceptanceBetsStopped_root__xTD16","content":"AcceptanceBetsStopped_content__gmQvU","icon":"AcceptanceBetsStopped_icon__HVSON","text":"AcceptanceBetsStopped_text__piKwi"};